module.exports = __webpack_public_path__ + "95e7038e41ba2e91d7c8c4a47db00edb.svg";